"use client";

import React, { useState } from "react";

import Image from "next/image";

interface ImageLightboxProps {
  src: string;
  alt: string;
  width: number;
  height: number;
  className?: string;
}

const ImageLightbox: React.FC<ImageLightboxProps> = ({
  src,
  alt,
  width,
  height,
  className = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const openLightbox = () => setIsOpen(true);
  const closeLightbox = () => setIsOpen(false);

  return (
    <>
      <Image
        src={src}
        alt={alt}
        width={width}
        height={height}
        className={`cursor-pointer ${className}`}
        onClick={openLightbox}
      />

      {isOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80"
          onClick={closeLightbox}
        >
          <div className="relative max-w-[90vw] max-h-[90vh]">
            <button
              className="absolute -top-10 right-0 p-2 text-white text-2xl"
              onClick={closeLightbox}
            >
              ✕
            </button>
            <Image
              src={src}
              alt={alt}
              width={width * 1.5}
              height={height * 1.5}
              className="max-w-full max-h-[85vh] object-contain"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ImageLightbox;
